<template>
    <div class="medialibrary__list">
        <div class="medialibrary_list_header">
            <view-actions
                :title="$t('lms.mediaLibrary.titles.mediaLibrary')"
                :cancel-button-active="false"
                :submit-button-active="allowComponentLibrary"
                :submit-button-text="$t('lms.mediaLibrary.buttons.upload')"
                :submit-button-icon="true"
                :submit-button-icon-name="'upload'"
                :submit-button-icon-align="'right'"
                @emit-submit="openFileUploader"
            />
        </div>
        <div class="medialibrary__list_main">
            <template v-if="allowComponentLibrary">
                <component-library
                    :item-name="['file', 'files']"
                    ref="componentlibrary"
                />
            </template>
            <template v-else>
                <div class="medialibrary__list_main_error">
                    <div class="container">
                        <div class="columns is-vcentered">
                            <div class="column"></div>
                            <div class="column is-narrow">
                                <component-note>{{ $t('lms.mediaLibrary.text.selectWorkspace') }}</component-note>
                            </div>
                            <div class="column"></div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import ComponentLibrary from '@/components/default/shared/ComponentLibrary'
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentNote from '@/components/default/shared/ComponentNote'

export default {
  name: 'media-library-list',
  components: { ComponentNote, ViewActions, ComponentLibrary },
  computed: {
    secondStageTokenHasCustomerId () {
      return Boolean(this.$store.getters.getAuthUserSecondStageTokenDataCustomerId)
    },
    secondStageTokenIsFromOldLMS () {
      return this.$store.getters.getAuthUserIsSecondStageTokenOldLMS
    },
    allowComponentLibrary () {
      return this.secondStageTokenIsFromOldLMS ? true : this.secondStageTokenHasCustomerId
    }
  },
  methods: {
    openFileUploader () {
      this.$refs.componentlibrary.openFileUploader()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/media-library/_medialibrarylist.scss";
</style>
